import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cms" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BlockContents = _resolveComponent("BlockContents")!
  const _component_SpecialPage = _resolveComponent("SpecialPage")!
  const _component_TopNewsNormal = _resolveComponent("TopNewsNormal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.contents_type === 'block_contents')
      ? (_openBlock(), _createBlock(_component_BlockContents, {
          key: 0,
          location_code: _ctx.location_code,
          onHasContents: _ctx.onHasContents
        }, null, 8, ["location_code", "onHasContents"]))
      : (_ctx.contents_type === 'special_page')
        ? (_openBlock(), _createBlock(_component_SpecialPage, {
            key: 1,
            view_type: _ctx.view_type,
            page_limit: _ctx.page_limit,
            view_area: _ctx.view_area,
            show_more: _ctx.show_more,
            onCatchTitle: _ctx.setTitle
          }, null, 8, ["view_type", "page_limit", "view_area", "show_more", "onCatchTitle"]))
        : _createCommentVNode("", true),
    (_ctx.contents_type === 'news')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.view_type === 'TopNewsNormal')
            ? (_openBlock(), _createBlock(_component_TopNewsNormal, {
                key: 0,
                item_list: _ctx.item_list
              }, null, 8, ["item_list"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}